<template>
  <div>
    <!-- Apply for a job popup -->
    <div v-if="isResumeBox" class="" tabindex="-1">
      <div class="mfp-bg  mfp-ready modal-bg">
        <div
          class="
            mfp-wrap mfp-close-btn-in mfp-auto-cursor
            my-mfp-zoom-in
            mfp-ready
          "
          style="top: 33.75px; position: absolute; height: 482px"
        >
          <div class="mfp-container mfp-inline-holder">
            <div class="mfp-content">
              <div id="small-dialog" class="zoom-anim-dialog dialog-with-tabs">
                <!--Tabs -->
                <div class="sign-in-form">
                  <ul class="popup-tabs-nav">
                    <li>
                      <a href="#tab" title="Cover letter tab">Apply Now</a>
                    </li>
                  </ul>

                  <div class="popup-tabs-container">
                    <!-- Tab -->
                    <div class="popup-tab-content" id="tab">
                      <!-- Welcome Text -->
                      <div class="welcome-text">
                        <h3 title="Cover letter heading">Cover letter</h3>
                      </div>

                      <!-- Form -->
                      <form id="apply-now-form">
                        <label
                          for="cover-letter"
                          title="Cover letter instructions"
                          >Introduce yourself and explain why you’re a strong
                          candidate for this job.</label
                        >
                        <textarea
                          name="cover-letter"
                          id="cover-letter"
                          cols="30"
                          rows="8"
                          class="input-text with-border"
                          placeholder="Enter cover letter"
                          required
                          v-model="coverLetter"
                          title="Enter your cover letter"
                        ></textarea>
                      </form>

                      <!-- Button -->
                      <button
                        class="
                          button
                          margin-top-35
                          full-width
                          button-sliding-icon
                          ripple-effect
                        "
                        type="submit"
                        @click="applyToProject()"
                        title="Submit your cover letter"
                      >
                        Apply Now
                        <i class="icon-material-outline-arrow-right-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="mfp-close"
                  @click="isResumeBox = false"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Apply for a job popup / End -->

    <div v-if="currentProject && currentProject.id">
      <!-- Titlebar -->
      <div
        class="single-page-header"
        data-background-image="images/single-job.jpg"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="single-page-header-inner">
                <div class="left-side">
                  <div class="header-details">
                    <h3 title="Job title">{{ currentProject.title }}</h3>

                    <ul>
                      <li>
                        <div
                          v-if="currentProject.posted_on"
                          class="verified-badge-with-title"
                        >
                          Payment Verified 
                        </div>
                      </li>
                      <br />
                      <li class="tex-primary">
                        <a
                          href="#"
                          title="Job owner name"
                          @click="viewProfile(currentProject.owner.id)"
                          ><i class="icon-material-outline-business"></i> Posted
                          by: {{ currentProject.owner.name }}</a
                        >
                      </li>

                      <br />
                      <li title="Job location">
                        <i class="icon-material-outline-location-on"></i>
                        {{
                          currentProject.region
                            ? currentProject.region.name
                            : ""
                        }}
                      </li>
                      <li title="Job location">
                        <i class="icon-material-outline-location-on"></i>
                        Task type:
                        {{
                          currentProject.subtask
                            ? currentProject.subtask.name
                            : ""
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="right-side">
                  <div class="salary-box">
                    <div class="salary-type">Budget Amount</div>
                    <div class="salary-amount" title="Job budget">
                      {{ formatAmount(currentProject.budget) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content
================================================== -->
      <div class="container">
        <div class="row">
          <!-- Content -->
          <div class="col-xl-8 col-lg-8 content-right-offset">
            <div class="single-page-section">
              <h3 class="margin-bottom-25">Description</h3>
              <p title="Job description">{{ currentProject.description }}</p>
            </div>

            <!-- Photo Atachments -->
            <div class="single-page-section">
              <h3>Attachments</h3>
              <div
                v-if="currentProject.photos && currentProject.photos.length"
                class="attachments-container"
              >
                <a
                  :href="photo['url']"
                  class="attachment-box ripple-effect"
                  v-for="(photo, index) in currentProject.photos"
                  :key="photo[0]"
                  target="_blank"
                  :title="photo['url']"
                  ><span>Doc {{ index + 1 }}</span
                  ><i>PNG</i></a
                >
              </div>
              <div v-else>No attachements</div>
            </div>

            <div
              class="single-page-section"
              v-if="relatedProjects && relatedProjects.length"
            >
              <h3 class="margin-bottom-25">Related Jobs</h3>

              <!-- Listings Container -->
              <div class="listings-container grid-layout">
                <!-- Job Listing -->

                <a
                  class="job-listing clickable"
                  v-for="(relatedProject, index) in relatedProjects.slice(0, 2)"
                  :key="index"
                  @click="viewProject(relatedProject.id)"
                  title="Similar project"
                >
                  <!-- Job Listing Details -->
                  <div class="job-listing-details">
                    <!-- Logo -->
                    <div
                      v-if="
                        relatedProject.photos && relatedProject.photos.length
                      "
                      class="job-listing-company-logo"
                    >
                      <img
                        :src="relatedProject.photos[0]['url']"
                        alt=""
                        title="Similar project photo"
                      />
                    </div>

                    <!-- Details -->
                    <div class="job-listing-description">
                      <h4
                        class="job-listing-company"
                        title="Similar project task"
                      >
                        {{ relatedProject.task.name }}
                      </h4>
                      <h3
                        class="job-listing-title"
                        title="Similar project subtask"
                      >
                        {{ relatedProject.subtask.name }}
                      </h3>
                    </div>
                  </div>

                  <!-- Job Listing Footer -->
                  <div class="job-listing-footer">
                    <ul>
                      <li title="Similar project country">
                        <i class="icon-material-outline-location-on"></i>
                        {{
                          relatedProject.region
                            ? relatedProject.region.name
                            : ""
                        }}
                      </li>
                      <li title="Similar project type">
                        <i class="icon-material-outline-business-center"></i>
                        {{ relatedProject.model === 1 ? "Remote" : "On-site" }}
                      </li>
                      <li title="Similar project budget">
                        <i
                          class="icon-material-outline-account-balance-wallet"
                        ></i>
                        {{ formatAmount(relatedProject.budget) }}
                      </li>
                      <li title="Similar project date">
                        <i class="icon-material-outline-access-time"></i>
                        {{ formatDate(relatedProject.updated_at) }}
                      </li>
                    </ul>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <!-- Sidebar -->
          <div class="col-xl-4 col-lg-4">
            <div class="sidebar-container">
              <a
                href="#"
                @click="isResumeBox = true"
                class="apply-now-button popup-with-zoom-anim text-light "
                :class="[hasApplied ? 'isDisabled' : '']"
              >
                {{ hasApplied ? "Already Applied" : "Apply Now" }}
                <i class="icon-material-outline-arrow-right-alt"></i
              ></a>

              <!-- Sidebar Widget -->
              <div class="sidebar-widget">
                <div class="job-overview">
                  <div class="job-overview-headline">Job Summary</div>
                  <div class="job-overview-inner">
                    <ul>
                      <li title="Job address">
                        <i class="icon-material-outline-location-on"></i>
                        <span>Location</span>
                        <h5>{{ currentProject.address }}</h5>
                      </li>
                      <li title="Job type">
                        <i class="icon-material-outline-business-center"></i>
                        <span>Job Type</span>
                        <h5>
                          {{
                            currentProject.model === 1 ? "Remote" : "On-site"
                          }}
                        </h5>
                      </li>
                      <li title="Job budget">
                        <i
                          class="icon-material-outline-account-balance-wallet"
                        ></i>
                        <span>Budget</span>
                        <h5>
                          {{ formatAmount(currentProject.budget) }}
                        </h5>
                      </li>
                      <li class="Job task">
                        <i class="icon-material-outline-local-offer"></i>
                        <span>Task</span>
                        <h5>
                          {{
                            currentProject.task ? currentProject.task.name : ""
                          }}
                        </h5>
                      </li>
                      <li class="Job subtask">
                        <i class="icon-material-outline-loyalty"></i>
                        <span>Subtask</span>
                        <h5>
                          {{
                            currentProject.subtask
                              ? currentProject.subtask.name
                              : ""
                          }}
                        </h5>
                      </li>
                      <li class="Job time">
                        <i class="icon-material-outline-access-time"></i>
                        <span>Date Posted</span>
                        <h5>{{ formatDate(currentProject.updated_at) }}</h5>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <!-- Sidebar Widget -->
              <div class="sidebar-widget">
                <h3>Save Job</h3>

                <!-- Bookmark Button -->
                <button
                  class="bookmark-button margin-bottom-25"
                  :class="[isBookmarked ? 'bookmarked' : '']"
                  v-on="
                    isBookmarked
                      ? { click: () => unFavouriteProject(currentProject.id) }
                      : { click: () => favouriteProject(currentProject.id) }
                  "
                >
                  <span
                    class="bookmark-icon"
                    :class="[isBookmarked ? 'bookmarked' : '']"
                    v-on="
                      isBookmarked
                        ? { click: () => unFavouriteProject(currentProject.id) }
                        : { click: () => favouriteProject(currentProject.id) }
                    "
                  ></span>
                  <span class="bookmark-text">Save</span>
                  <span class="bookmarked-text">Saved</span>
                </button>

                <!-- Copy URL -->
                <div class="copy-url">
                  <input
                    id="copy-url"
                    type="text"
                    :value="pageUrl"
                    class="with-border"
                  />
                  <button
                    @click="copyToClipboard()"
                    class="copy-url-button ripple-effect"
                    data-clipboard-target="#copy-url"
                    title="Copy to Clipboard"
                    data-tippy-placement="top"
                  >
                    <i class="icon-material-outline-file-copy"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCall, postCall } from "../../../core/services/http.service";
import {
  GET_SINGLE_PROJECT,
  GET_FAVOURITE_PROJECTS_IDS,
  RELATED_PROJECTS,
  FAVOURITE_A_PROJECT,
  UNFAVOURITE_A_PROJECT,
} from "../../../core/config/endpoints/projects";
import {
  APPLY_TO_PROJECT,
  PROJECT_APPLICATION_IDS,
} from "../../../core/config/endpoints/project-applications";
import { formatAmount, formatDate } from "../../../plugins/handlers";
import Snackbar from "node-snackbar";

export default {
  name: "ProjectDetails",
  components: {},
  data() {
    return {
      currentProject: {},
      isBookmarked: false,
      relatedProjects: [],
      isResumeBox: false,
      coverLetter: null,
      hasApplied: false,
    };
  },
  methods: {
    formatAmount(amount) {
      return formatAmount(amount);
    },

    getProjectDetails(id) {
      this.$store.commit("setIsLoaded", true);
      getCall(`${GET_SINGLE_PROJECT.SINGLE_PROJECT(id)}`)
        .then(response => {
          console.log(response)
          this.currentProject = response.data.data[0];
          this.getRelatedProjects(this.currentProject.task_id);
        })
        .catch(error => {
          // if (parseInt(error.response.status) == 404)
          //   return this.$router.push({ name: "NotFound" });
          // this.$store.commit("setNotify", {
          //   type: "error",
          //   message: error.response.data.message,
          //   status: true,
          // });
          console.log(error)
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getRelatedProjects(id) {
      if (!id) return false;
      this.$store.commit("setIsLoaded", true);
      getCall(`${RELATED_PROJECTS}${id}`)
        .then(response => {
          this.relatedProjects = response.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    viewProject(projectId) {
      window.location.href = `${this.$route.path}?id=${projectId}`;
    },

    getFavouriteProjectIds() {
      this.$store.commit("setIsLoaded", true);
      getCall(GET_FAVOURITE_PROJECTS_IDS)
        .then(response => {
          if (response.data.data.includes(parseInt(this.$route.query.id))) {
            this.isBookmarked = true;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    favouriteProject(id) {
      postCall(FAVOURITE_A_PROJECT, { project_id: id })
        .then(() => {
          this.$toast.success("Job saved!");

          this.isBookmarked = !this.isBookmarked;
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {});
    },
    unFavouriteProject(id) {
      postCall(UNFAVOURITE_A_PROJECT, { project_id: id })
        .then(() => {
          this.$toast.success("Job unsaved!");

          this.isBookmarked = !this.isBookmarked;
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {});
    },
    applyToProject() {
      this.isResumeBox = false;
      this.$store.commit("setIsLoaded", true);
      postCall(APPLY_TO_PROJECT, {
        resume: this.coverLetter,
        project_id: this.$route.params.id,
      })
        .then(response => {
          this.$toast.success(`${response.data.message}`);

          this.hasApplied = true;
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false); 
        });
    },
    getProjectApplicationIds() {
      getCall(PROJECT_APPLICATION_IDS)
        .then(response => {
          if (response.data.data.includes(parseInt(this.$route.query.id))) {
            this.hasApplied = true;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    viewProfile(id) {
      this.$router.push({ name: "Profile", query: { id: `${id}` } });
    },
    copyToClipboard() {
      Snackbar.show({
        text: "Copied to clipboard!",
        pos: "bottom-center",
        showAction: false,
        actionText: "Dismiss",
        duration: 5000,
        textColor: "#fff",
        backgroundColor: "#383838",
      });
    },
    formatDate(dateTime) {
      return formatDate(dateTime);
    },
  },

  mounted() {
    this.getProjectDetails(this.$route.params.id);
    this.getRelatedProjects(this.$route.params.id);
    if (this.$store.state.token) {
      this.getFavouriteProjectIds();
      this.getProjectApplicationIds();
    }
  },
  computed: {
    pageUrl() {
      return window.location.href;
    },
  },
};
</script>

<style scoped>
.main-page .right .nav-tabs li a.active {
  cursor: text;
}

.modal-bg {
  background: #1111117d !important;
}

.isDisabled {
  color: #333333 !important ;
  cursor: not-allowed !important ;
  opacity: 0.5 !important ;
  text-decoration: none !important ;
  pointer-events: none !important ;
  background-color: #f0f0f0;
}

.isDisabled:hover {
  cursor: not-allowed;
}
</style>
